/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Cap_Apps_Author_Floor_TooltipInputs */



/**
* | output |
* | --- |
* | "When on, dashboard authoring is floored to admins regardless of this capability — this governs dashboards only; canvas is unaffected. The change is written t..." |
*
* @param {Rights_Cap_Apps_Author_Floor_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_cap_apps_author_floor_tooltip = /** @type {((inputs?: Rights_Cap_Apps_Author_Floor_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Cap_Apps_Author_Floor_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenn aktiviert, ist das Erstellen von Dashboards unabhängig von dieser Berechtigung auf Admins beschränkt – dies betrifft nur Dashboards; Canvas bleibt unberührt. Die Änderung wird über das Compliance-Protokoll geschrieben.")
	return /** @type {LocalizedString} */ ("When on, dashboard authoring is floored to admins regardless of this capability — this governs dashboards only; canvas is unaffected. The change is written through the compliance log.")
});